function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { default as LinkWrapper } from '@mui/material/Link';
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color } from "../../utils/index.js";
export var APPEARANCES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DESTRUCTIVE: 'destructive',
  AQUA_PRESSED: 'aqua_pressed',
  DEFAULT: 'default'
};
export var FONTSIZE = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
function getFontColor(fontColor) {
  var appearancesDef = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, APPEARANCES.PRIMARY, color(COLOR_VARIANTS.AQUA100)), APPEARANCES.SECONDARY, color(COLOR_VARIANTS.MINESHAFT)), APPEARANCES.DESTRUCTIVE, color(COLOR_VARIANTS.CORAL100)), APPEARANCES.AQUA_PRESSED, color(COLOR_VARIANTS.AQUAPRESSED)), APPEARANCES.DEFAULT, color(COLOR_VARIANTS.WHITE));
  return appearancesDef[fontColor] || appearancesDef[APPEARANCES.PRIMARY];
}
function getFontSize(fontSize) {
  var appearancesDef = _defineProperty(_defineProperty(_defineProperty({}, FONTSIZE.SMALL, '12px'), FONTSIZE.MEDIUM, '14px'), FONTSIZE.LARGE, '16px');
  return appearancesDef[fontSize] || appearancesDef[FONTSIZE.MEDIUM];
}
export var Link = function Link(_ref) {
  var appearance = _ref.appearance,
    fontSize = _ref.fontSize,
    children = _ref.children,
    onClick = _ref.onClick,
    target = _ref.target,
    href = _ref.href,
    testId = _ref.testId,
    noPadding = _ref.noPadding,
    id = _ref.id,
    rel = _ref.rel;
  return /*#__PURE__*/React.createElement(LinkWrapper, {
    className: "__ds__comp",
    "data-testid": testId,
    id: id,
    color: appearance ? getFontColor(appearance) : color(COLOR_VARIANTS.AQUA100),
    variant: TYPOGRAPHY_VARIANT.HEADING4SEMBLD,
    onClick: onClick,
    underline: "none",
    href: href,
    target: target,
    sx: {
      padding: noPadding ? '0' : '10px 16px',
      cursor: 'pointer',
      fontSize: fontSize ? getFontSize(fontSize) : '14px'
    },
    rel: rel
  }, children || 'Label');
};